import type { ComponentType } from 'react'

import type { IconsIconComponent } from '@twisto/api-cms'
import * as InlineSvgIcons from '@twisto/icons/inline'
import type { SvgProps } from '@twisto/icons/types'
import { createSvgIconFromGenerated } from '@twisto/icons/utils'

export const Icon = ({ name, color, size }: IconsIconComponent) => {
  const svg = name && InlineSvgIcons[name]

  const RenderIcon = createSvgIconFromGenerated(
    svg as ComponentType<SvgProps>,
    name || ''
  )

  return <RenderIcon color={color} size={size} />
}
